var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "nav-link",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList"),
      },
    },
    [
      _c(
        "svg",
        {
          class: { "svg-filled": _vm.wishListCount },
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24.485",
            height: "21.599",
            viewBox: "0 0 24.485 21.599",
          },
        },
        [
          _c(
            "g",
            { attrs: { id: "Icon", transform: "translate(0.95 0.95)" } },
            [
              _c("path", {
                attrs: {
                  id: "Path",
                  d: "M22.134,4.24a5.943,5.943,0,0,0-8.407,0L12.583,5.385,11.438,4.24a5.944,5.944,0,0,0-8.407,8.405l1.146,1.145L12.583,22.2l8.405-8.407,1.146-1.145A5.942,5.942,0,0,0,22.134,4.24Z",
                  transform: "translate(-1.29 -2.499)",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.9",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }